import React from 'react';
import List from '@mui/material/List';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import SendIcon from '@mui/icons-material/Send';
import { ListItemButton } from '@mui/material';

import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';
import StarBorder from '@mui/icons-material/StarBorder';
import { NavLink } from 'react-router-dom';
import PermMediaIcon from '@mui/icons-material/PermMedia';


const DashMenu = ({ handleDrawerToggle }) => {
    const [openEvent, setOpenEvent] = React.useState(false);
    const [openAnother, setOpenAnother] = React.useState(false);

    const handleEventClick = () => {
        setOpenEvent(!openEvent);
    };
    const handleAnotherClick = () => {
        setOpenAnother(!openAnother);
    };
    return (
        <>

            <List>
                <ListItemButton as={NavLink} to="/dashboard/media" sx={{ color: '#fff' }} divider>
                    <ListItemIcon sx={{ color: ' #fff' }}>
                        <PermMediaIcon />
                    </ListItemIcon>
                    <ListItemText primary="Media" />
                </ListItemButton>
                <ListItemButton sx={{ color: '#fff' }} divider>
                    <ListItemIcon sx={{ color: ' #fff' }}>
                        <SendIcon />
                    </ListItemIcon>
                    <ListItemText primary="Sent mail" />
                </ListItemButton>
                <ListItemButton sx={{ color: '#fff' }} divider>
                    <ListItemIcon sx={{ color: ' #fff' }}>
                        <SendIcon />
                    </ListItemIcon>
                    <ListItemText primary="Sent mail" />
                </ListItemButton>
                <>
                    <ListItemButton sx={{ color: '#fff' }} onClick={handleEventClick} divider>
                        <ListItemIcon sx={{ color: ' #fff' }}>
                            <SendIcon />
                        </ListItemIcon>
                        <ListItemText primary="Inbox" />
                        {openEvent ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                    <Collapse in={openEvent} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            <ListItemButton sx={{ color: '#fff', pl: 4 }} as={NavLink} to="/dashboard/events" onClick={handleDrawerToggle} divider>
                                <ListItemIcon sx={{ color: ' #fff' }}>
                                    <StarBorder />
                                </ListItemIcon>
                                <ListItemText primary="Mange Events" />
                            </ListItemButton>
                            <ListItemButton sx={{ color: '#fff', pl: 4 }} as={NavLink} to="/dashboard/events/add-new" onClick={handleDrawerToggle} divider>
                                <ListItemIcon sx={{ color: ' #fff' }}>
                                    <StarBorder />
                                </ListItemIcon>
                                <ListItemText primary="Add New Event" />
                            </ListItemButton>

                        </List>
                    </Collapse>
                </>
                <>
                    <ListItemButton sx={{ color: '#fff' }} onClick={handleAnotherClick} divider>
                        <ListItemIcon sx={{ color: ' #fff' }}>
                            <SendIcon />
                        </ListItemIcon>
                        <ListItemText primary="Inbox" />
                        {openAnother ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                    <Collapse in={openAnother} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            <ListItemButton sx={{ color: '#fff', pl: 4 }} >
                                <ListItemIcon sx={{ color: ' #fff' }}>
                                    <StarBorder />
                                </ListItemIcon>
                                <ListItemText primary="Starred" />
                            </ListItemButton>
                        </List>
                    </Collapse>
                </>

            </List>
        </>
    );
};

export default DashMenu;